export default __webpack_public_path__ + "static/4-32f84026914db23ad1682f7713693db9.jpeg";